import { render, staticRenderFns } from "./BookingForm.vue?vue&type=template&id=c2a68af8&scoped=true"
import script from "./BookingForm.vue?vue&type=script&lang=js"
export * from "./BookingForm.vue?vue&type=script&lang=js"
import style0 from "./BookingForm.vue?vue&type=style&index=0&id=c2a68af8&prod&lang=css"
import style1 from "./BookingForm.vue?vue&type=style&index=1&id=c2a68af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a68af8",
  null
  
)

export default component.exports